import React, { Component, Fragment } from 'react';
import Icons from '../../layouts/Icons';
import Cta from '../../layouts/Cta';
import Facilities from '../../layouts/Facilities';
import Contactform from '../../layouts/Contactform';
import SearchField from './SearchField';

class Content extends Component {
    render() {
        return (
            <Fragment>
                <SearchField />
                <div className="section section-padding pt-0">
                    <div className="container">
                        <Icons />
                    </div>
                </div>
                {/* <Cta/> */}
                {/* <div className="section section-padding">
                    <div className="container">
                        <Facilities/>
                    </div>
                </div> */}
                {/* <Blogpost/> */}
            </Fragment>
        );
    }
}

export default Content;